import { RouteType } from "types/RouteType";

const BOMWorkflowRoute: RouteType = {
  name: "BOM Workflow",
  path: "/workflows/bom",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./BOMWorkflowHeader"),
      title: "Bill of Materials",
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./BOMWorkflow"),
      grayBackground: true,
    },
  },
  requiresPermission: false,
  beforeEnter: async ({ rootStore }) => {
    // Load products if not already loaded
    if ((rootStore as any).productsStore.entities.length === 0) {
      await (rootStore as any).productsStore.find({
        query: {
          $limit: 2000,
        },
      });
    }

    // Load BOM components if not already loaded
    if ((rootStore as any).bomComponentsStore?.entities.length === 0) {
      await (rootStore as any).bomComponentsStore.find({
        query: {
          $limit: 2000,
        },
      });
    }

    // Optionally load existing product BOMs
    if ((rootStore as any).productBomStore) {
      await (rootStore as any).productBomStore.find({
        query: {
          $limit: 2000,
        },
      });
    }

    return true;
  },
  onParamsChange: async ({ rootStore, queryParams }) => {
    // Handle productId if passed as query param
    if (queryParams?.productId && (rootStore as any).bomViewStore) {
      const productId = queryParams.productId;
      if (productId) {
        (rootStore as any).bomViewStore.setSelectedProduct(productId);
      }
    }
  },
};

export default BOMWorkflowRoute;
